export default class LimitedButton {
	constructor($element) {
		this.$element = $element;
		this.$element.each((i, el) => {
			const dateElement = $(el).find('.cta-limited-button-date').get(0);
			this.initializeTimer(dateElement);
		});
	}

	initializeTimer(element) {
		const endTime = element.dataset.end;
		const timeInterval = setInterval(() => {
			setTime()
			this.updatePercentage(element);
		},1000);

		const setTime = () => {
			const t = this.getTimeRemaining(endTime);
			const days = element.querySelector('.cta-limited-button-date-days');
			if (days) {
				if (t.days === 0) {
					$(days).closest('.cta-limited-button-digit').remove();
				} else {
					days.innerText = t.days;
				}
			}

			const hours = element.querySelector('.cta-limited-button-date-hours');
			if (hours) {
				if (t.days === 0 && t.hours === 0) {
					$(hours).closest('.cta-limited-button-digit').remove();
				} else {
					hours.innerText = t.hours;
				}
			}

			const minutes = element.querySelector('.cta-limited-button-date-minutes');
			if (minutes) {
				if (t.days === 0 && t.hours === 0 && t.minutes === 0) {
					$(minutes).closest('.cta-limited-button-digit').remove();
				} else {
					minutes.innerText = t.minutes;
				}
			}

			const seconds = element.querySelector('.cta-limited-button-date-seconds');
			if (seconds) {
				if (t.days === 0 && t.hours === 0 && t.minutes === 0 && t.seconds === 0) {
					$(seconds).closest('.cta-limited-button-digit').remove();
				} else {
					seconds.innerText = t.seconds;
				}
			}

			if (t.total <= 0) {
				clearInterval(timeInterval);

				if (!!this.$element.data('hide-when-ended')) {
					this.$element.fadeOut(300, () => {
						this.$element.remove();
					});
				} else {
					const $text = this.$element.find('.cta-limited-button-text');
					if ($text.length) {
						$text.remove();
					}

					this.$element.addClass('ended');
				}
			}
		};

		setTime();
		this.updatePercentage(element);
		this.$element.addClass('initialized');
	}

	updatePercentage(element) {
		const startTime = element.dataset.start;
		const endTime = element.dataset.end;
		const totalTime = endTime - startTime;
		const now = Date.now();
		const elapsedTime = now - startTime;
		const percentage = 100 - (elapsedTime / totalTime) * 100;

		this.$element.css('--percentage', `${Math.max(0, percentage.toFixed(2))}%`);
	}
	getTimeRemaining(endTime) {
		const now = Date.now();
		const total = endTime - now;
		const seconds = Math.floor((total/1000) % 60);
		const minutes = Math.floor((total/1000/60) % 60);
		const hours = Math.floor((total/(1000*60*60)) % 24);
		const days = Math.floor(total/(1000*60*60*24));

		return {
			total,
			days,
			hours,
			minutes,
			seconds
		};
	}
}
